import { IoDocument } from "react-icons/io5";

import { SiDiscord, SiTelegram, SiX } from "@icons-pack/react-simple-icons";

const links = [
  {
    text: "©Bento Labs",
    href: "",
  },
  {
    text: "Terms",
    href: "#",
  },
  { text: "Privacy Policy", href: "#" },
];

const socialList = [
  {
    icon: <IoDocument className="text-nobel/50 size-6.5" />,
    link: "#",
  },
  {
    icon: <SiX className="text-nobel/50 size-6.5" />,
    link: "#",
  },
  {
    icon: <SiDiscord className="text-nobel/50 size-6.5" />,
    link: "#",
  },
  {
    icon: <SiTelegram className="text-nobel/50 size-6.5" />,
    link: "#",
  },
];

export const Footer = () => {
  return (
    <footer className="mt-auto flex flex-col-reverse items-center justify-center gap-y-7 px-7.5 py-6 text-sm leading-[145%] backdrop-blur-xl sm:flex-row">
      <ul className="text-nobel flex gap-3 sm:gap-7.5">
        {links.map((item) => {
          return (
            <li key={item.text}>
              {item.href && (
                <a
                  className="transition-colors hover:brightness-125"
                  href={item.href}
                >
                  {item.text}
                </a>
              )}
              {!item.href && <span className="text-nobel/50">{item.text}</span>}
            </li>
          );
        })}
      </ul>

      <ul className="mx-auto flex items-center gap-x-7.5 sm:mr-0">
        {socialList.map((item) => {
          return (
            <li key={item.link}>
              <a
                className="transition-colors hover:brightness-125"
                href={item.link}
              >
                {item.icon}
              </a>
            </li>
          );
        })}
      </ul>
    </footer>
  );
};
